import React from 'react';
import { TOperation } from "../../util/varibles/interface";
import styles from './style.module.scss';

interface IProps {
    visible?: boolean
    operation: TOperation
    className?: string
}

const SiteUnit: React.FC<IProps> = (props) => {
    const { site_name, sub_operations, sites = [], site = { name: '' } } = props.operation;
    const { visible = true, className = '' } = props;

    if (!visible) return null;

    let value;
    value = sites.length === 0
        ? [site_name || site.name, sub_operations.map(item => item.unit_id).join(', ')].join(' - ')
        : sites.map((item: any) => {
            return [item.name, sub_operations.reduce((list: string[], sub) =>
                sub.site_id === item.id ? [...list, sub.unit_id] : list
                , []).join(', ')].join(' - ')
        }).join(' | ')

    return <div className={`${styles['site-unit']} ${className}`} title={value}>
        {value}
    </div>
};

export default SiteUnit;
